﻿import { getCurrentLanguage } from '@src/shared/lib/culture';

import type { LocaleKey } from '../../types/modules/locale';

import { localeDict } from './locale-dict';

type LocaleDictValue = (typeof localeDict)[LocaleKey];

/**
 * Ключ словаря — короткий ISO-код языка страницы (`ru`/`en`/`th`/`tr`).
 * При добавлении нового языка обновляй `localeDict`.
 */
const getLocaleDict = (): LocaleDictValue => {
    const locale = getCurrentLanguage() as LocaleKey;

    return localeDict[locale];
};

window.getLocaleDict = getLocaleDict;
